<template>
  <div>
  <div class="d-none d-sm-block">
      <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Übersicht</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Benutzer</li>
      </ol>
    </nav>
   </div>
   <div class="mt-3 clearfix">

   <b-button class="float-right" size="md" v-b-toggle.collapse-user-form variant="light"><i class="bi bi-person-plus"></i></b-button>

 <b-form-radio-group v-if="showFunctions()" class="float-right" v-model="listView" buttons button-variant="light">
   <b-form-radio class="mr-1" :value="true"><i class="bi bi-list"></i></b-form-radio>
   <b-form-radio class="mr-2" :value="false"><i class="bi bi-grid-3x3-gap"></i></b-form-radio>
</b-form-radio-group>
  </div>
  <b-card no-body border-variant="light"  class="mt-3">
      <b-collapse id="collapse-user-form" accordion="my-accordion" role="tabpanel">
      <b-card-text>
<b-form @submit="onSubmit"  >
     <input autocomplete="false" name="hidden" type="text" style="display:none;">

 <b-form-group label-cols="12" label-cols-sm="2"
      id="input-group-name"
      label="Name:"
      label-for="input-name">
       <b-form-input placeholder="Namen eingeben..." v-model="userForm.name" id="input-1" type="text" required/>
  </b-form-group>
 <b-form-group label-cols="12" label-cols-sm="2"
      id="input-group-username"
      label="Anmeldename (Interne EMail):"
      :invalid-feedback="messages.username"
      :state="!messages.username"
      label-for="input-username">
       <b-form-input placeholder="Interne EMail/Anmeldename eingeben..." v-model="userForm.username" id="input-2" type="email" required/>
  </b-form-group>
 <b-form-group label-cols="12" label-cols-sm="2"
      id="input-group-password"
      label="Passwort"
      :invalid-feedback="messages.password"
      :state="!messages.password"
      label-for="input-password">
       <b-form-input placeholder="Passwort eingeben..." v-model="userForm.passwort" id="input-2" type="password"/>
  </b-form-group>
 <b-form-group label-cols="12" label-cols-sm="2"
      id="input-group-passwordrepeat"
      label="Passwort Wiederholung"
      label-for="input-passwordrepeat">
       <b-form-input placeholder="Passwort eingeben..." v-model="userForm.passwortRepeat" id="input-2" type="password"/>
  </b-form-group>
  <b-form-group label-cols="12" label-cols-sm="2"
      id="input-group-email"
      label="E-Mail:"
      label-for="input-email">
    <b-form-input label-cols="2"
      id="input-1"
      v-model="userForm.email"
      type="email"
      placeholder="E-Mail eingeben..."
      required >
       <b-form-text id="input-email">Primäre E-Mail Adresse</b-form-text>
   </b-form-input>
</b-form-group>

<b-form-group
      label="Standort"
      label-for="input-standort"
      label-cols="12" label-cols-sm="2">
      <b-form-select
          id="input-1" required
          v-model="userForm.standortId">
          <option v-for="(sp, idx) in standorte" v-bind:key="idx" :value="sp.id">{{sp.name}}</option>
      </b-form-select>
      </b-form-group>

 <b-form-group label-cols="12" label-cols-sm="2"

      label="Rollen"
      v-slot="{ ariaDescribedby }">
      <b-form-checkbox-group
        v-model="userForm.roles"
        :options="roleOptions"
        :aria-describedby="ariaDescribedby"
        name="flavour-1a"
      ></b-form-checkbox-group>
   </b-form-group>

  <b-form-group label-cols="12" label-cols-sm="2"
      id="input-group-action"
      label-for="input-action">

    <b-alert :show="messages['errorMessage']!=null" variant="warning">{{messages['errorMessage']}}</b-alert>

    <b-button size="sm" type="submit" variant="primary">Benutzer anlegen</b-button>

   </b-form-group>

    </b-form>

</b-card-text>
</b-collapse>
</b-card>

    <b-form-group
          label="Suche"
          label-for="filter-input"
          label-cols-sm="1"
          content-cols-sm="12" content-col="6"
          label-align-sm="left"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              debounce="500"
              placeholder="Muster eingeben..."
            ></b-form-input>
            <b-form-select
                id="input-search-role"
                class="ml-2"
                v-model="filterRole">
                <option value="0">Alle Rollen</option>
                <option v-for="(sp, idx) in roles" v-bind:key="idx" :value="sp.id">{{sp.id}}</option>
            </b-form-select>
          <b-input-group-append>
            <b-button :disabled="!filter && !filterRole" @click="filter = null;filterRole = 0">Löschen</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

<div class="" v-if="!listView">
<div class="row">
<div v-for="item in listValues" :key="item.id" class="col-sm-12 col-md-6 col-lg-3">

<b-link :href="`#/Benutzer/${item.id}`">
<b-card
    :title="item.name"
    :img-src="iconUrl(item)"
    img-alt="Profilbild"
    img-top
    tag="article"
    style="max-width: 20rem;"
    class="mb-2" >
    </b-card>
    </b-link>
</div>
</div>

</div>

<div class="table-responsive" v-if="listView">
    <b-table
     :show="items.length>0"
     :current-page="currentPage"
     :per-page="perPage"
     :busy.sync="loading"
     responsive="true"
     striped
     hover
     id="user-table"
     :items="itemProvider"
     :fields="fields">
     <template #table-busy>
        <div class="text-center  my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Lädt...</strong>
        </div>
      </template>

    <template #cell(name)="data">
      <b-link :href="`#/Benutzer/${data.item.id}`">{{data.value }}</b-link>
    </template>
    <template #cell(id)="data">
      <b-link :href="`#/Benutzer/${data.item.id}`">{{data.value }}</b-link>
    </template>

    <template #cell(enabled)="data">{{ data.value?'Ja':'Nein'}}</template>
    <template #cell(active)="data">{{ data.value?'Ja':'Nein'}}</template>

    <template #cell(roles)="data">
    <div v-for="role in data.item.roles" :key="role.id">
    {{role.id}}
    </div>
    </template>

    <template #cell(action)="data">
       <b-link :href="`/api/user/delete/${data.item.id}`" @click="confirm"><i class="bi bi-trash"></i></b-link>
    </template>
    </b-table>
</div>
   <b-pagination v-if="rows>perPage" v-model="currentPage" :total-rows="rows"
      :per-page="perPage" aria-controls="user-table"></b-pagination>

  </div>
</template>

<script>
import api from '@/api/benutzer'
import Role from '@/models/Role'
import utils from '@/utilities'
import afunc from '@/functions'

export default {
  name: 'Benutzer',
  data () {
    return {
      loading: false,
      user: this.$store.state.auth.user,
      standorte: this.$store.state.auth.baseData.standorte,
      preset: {'standortId': this.$store.state.auth.baseData.standorte[0].id},
      userForm: {'standortId': this.$store.state.auth.baseData.standorte[0].id},
      items: [],
      fields: ['id', 'name', { key: 'username', label: 'Benutzername' }, { key: 'active', label: 'anmelden' }, { key: 'enabled', label: 'auswählbar' }, 'roles', 'action'],
      roleOptions: Role.asOptions(this.$store.state.auth.baseData.roles),
      roles: this.$store.state.auth.baseData.roles,
      currentPage: 1,
      messages: {errorMessage: null},
      perPage: 50,
      rows: 0,
      totalRows: 0,
      filterRole: 0,
      listValues: [],
      listView: true,
      filter: null
    }
  },
  watch: {
    filterRole: function (value) {
      this.$root.$emit('bv::refresh::table', 'user-table')
    },
    filter: function (value) {
      this.$root.$emit('bv::refresh::table', 'user-table')
    }
  },
  mounted () {
    this.refresh()
  },
  methods: {
    showFunctions () {
      return afunc.showInternalFunctions(this.user)
    },
    iconUrl (item) {
      return '/api/user/profilePicture/' + (item ? item.id : 0) + '?' + new Date().getTime()
    },
    async itemProvider (ctx) {
      try {
        const offset = (ctx.currentPage - 1) * ctx.perPage
        const pagedList = await api.search(offset, ctx.perPage, {'name': this.filter, 'role': this.filterRole})
        this.rows = pagedList.size
        this.listValues = pagedList.items
        return pagedList.items
      } catch (error) {
        return []
      }
    },
    async onSubmit (event) {
      event.preventDefault()
      let httpForm = new FormData()
      for (let [key, value] of Object.entries(this.userForm)) {
        httpForm.append(key, value)
      }
      this.messages = await api.update(0, httpForm)
      if (Object.keys(this.messages).length === 0) {
        this.userForm = this.preset
        this.$root.$emit('bv::toggle::collapse', 'collapse-user-form')
        this.update()
        utils.makeToast(this, 'Benutzer angelegt!', 'success')
        this.userForm = {'standortId': this.$store.state.auth.baseData.standorte[0].id}
      }
    },
    async confirm (event) {
      event.preventDefault()
      let result = confirm('Diesen Benutzer löschen?')
      if (result) {
        result = await api.delete(event.target.parentElement.href)
        console.log(result)
        if (result && !result['errorMessage']) {
          this.update()
          utils.makeToast(this, 'Benutzer gelöscht!', 'success')
        } else {
          utils.makeToast(this, result['errorMessage'], 'danger', 'Fehler')
        }
      }
    },
    async update () {
      this.$root.$emit('bv::refresh::table', 'user-table')
    },
    async refresh () {
      this.update()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/BenutzerList.vue